import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import { Table } from 'react-bootstrap';

import { Web3StatusContext } from "../../../contexts/Web3StatusContext";
import TransactionStatus from '../../TransactionStatus'

const { AccountData, ContractData, ContractForm } = newContextComponents;

class PauseMainToken extends React.Component {
  static contextType = Web3StatusContext;

  state = {
    pausedDataKey: null,
    stackId: -1,
  };

  componentDidMount() {
    const { drizzle } = this.props;
    const contract = drizzle.contracts.GAMEFOREST;

    const pausedDataKey = contract.methods["paused"].cacheCall();
    
    this.setState({ pausedDataKey });
  }

  mySubmitHandler = (event) => {
    event.preventDefault();
    if(this.context.activeAccount == null) {
      console.log('no active account to approve');
      return;
    }
    const { drizzle } = this.props;
    const { GAMEFOREST, GAMEFORESTSale } = drizzle.contracts;

    var methodName = "pause";
    var pausedContract = this.props.drizzleState.contracts.GAMEFOREST["paused"][this.state.pausedDataKey];
    if(pausedContract != undefined) {
      if(pausedContract.value) {
        methodName = "unpause";
      }
    }

    const stackId = GAMEFOREST.methods[methodName].cacheSend();
    this.setState({ stackId: stackId });
  }

  // destructure drizzle and drizzleState from props
  render() {
    var statusMsg = '';
    if (this.state.stackId >= 0) {
      statusMsg = (
        <TransactionStatus
          drizzle={this.props.drizzle}
          drizzleState={this.props.drizzleState}
          stackId={this.state.stackId}
        >

        </TransactionStatus>
      );
    }

    var disabled = this.context.activeAccount == null;

    var pauseCaption = "Pause";
    if(!disabled) {
      const { GAMEFOREST } = this.props.drizzleState.contracts;

      var pausedContract = GAMEFOREST["paused"][this.state.pausedDataKey];
      if(pausedContract != undefined) {
        if(pausedContract.value) {
          pauseCaption = "unpause";
        }
      }
    }

    var form = (
    <form onSubmit={this.mySubmitHandler}>
        {statusMsg}<br/>
        <input
        type='submit'
        value={pauseCaption}
        disabled={disabled}
        />
        <br/>
    </form>
    );

    return (
      <div>
        {form}
      </div>
    );
  }
};

export default PauseMainToken;
